import { el } from 'redom';

import NativeHorizontalToggle from 'generics/components/horizontal-toggle/native';

import {
  determineNavigationSettings
} from './utilities';

import './index.scss';

class NavigationSettingsPanel {

  constructor(configuration) {

    this.menu = configuration.menu;
    this.node = configuration.node;
    this.onChange = configuration.onChange;

    this.navigationSettings = determineNavigationSettings(this.node);

    this.hamburgerToggle = new NativeHorizontalToggle({
      label: 'Show as menu',
      value: this.navigationSettings.hamburger.enabled,
      size: 'small',
      onChange: this.handleChange.bind(this)
    });
    this.el = el('.navigation-settings-panel-main', this.hamburgerToggle);

  }

  handleChange(value) {

    this.navigationSettings.hamburger.enabled = value;

    this.onChange(structuredClone(this.navigationSettings));

  }

  update(configuration) {

    this.manager = configuration.manager;

  }

}

export default NavigationSettingsPanel;